module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.slim) ? _c('nav', {
    staticClass: "navbar navbar-inverse navbar-sm"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "list-alt"
    }
  }), _vm._v(" Console")], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.clear()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash"
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    ref: "logs",
    staticClass: "logs",
    class: {
      slim: _vm.slim, normal: !_vm.slim
    }
  }, _vm._l((_vm.logs), function(data) {
    return _c('span', [_c('div', {
      staticClass: "log",
      class: data.level.cssClass
    }, [_c('div', {
      staticClass: "level"
    }, [(data.level.icon) ? _c('icon', {
      attrs: {
        "name": data.level.icon
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(data.key))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("consoleTime")(data.time)))]), _vm._v(" "), (!data.object) ? _c('div', {
      staticClass: "message"
    }, [_vm._v(_vm._s(data.message))]) : _c('div', {
      staticClass: "message"
    }, [_c('objectView', {
      model: {
        value: (data.message),
        callback: function($$v) {
          data.message = $$v
        },
        expression: "data.message"
      }
    })], 1)])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log head"
  }, [_c('div', {
    staticClass: "level"
  }), _vm._v(" "), _c('div', {
    staticClass: "key"
  }, [_vm._v("Module")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("Message")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c06ad2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/Console.vue
// module id = 1528
// module chunks = 2